import React from "react";
import styled from "styled-components";
import AboutSection from "./components/AboutSection";
import ExpertiseSection from "./components/ExpertiseSection";
import ContactSection from "../contact/components/ContactSection";

const Wrapper = styled.div``;

function AboutPage() {
  return (
    <Wrapper>
      <AboutSection />
      <ExpertiseSection />
    </Wrapper>
  );
}

export default AboutPage;
